import React, { Component } from 'react'
import { connect } from 'react-redux';
import PartnerEditScreeningTable from '../../component/privatescreening/PartnerEditScreeningTable';
import Select from 'react-select';
import TextField from './../../component/TextField'
import Cookies from 'universal-cookie';
//moment import
import moment from "moment-timezone";

//  Date Picker
import DatePicker from "react-datepicker";
import CalendarIcon from '../../icons/calendaricon';
import service from '../../services';
import SimpleReactValidator from 'simple-react-validator';
import ErrorPopUp from '../../component/errorPopUp'
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import ReactPaginate from 'react-paginate';
import CopyToClipboard from "copy-to-clipboard";
import { Link } from 'react-router-dom';
import commonImage from '../../commonImage';
import Loader from '../../component/loader';
import DropdownMaster from '../../component/DropdownMaster';
import cloud from "../../assets/images/cloud.svg";
import CsvUploadModalScreening from './CsvUploadModalScreening'
const cookies = new Cookies();


let sub;
class PartnersEditScreenings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            imagePreloader: false,
            createOpen: false,
            locationTypeText: '1',
            screenLocation: [],
            countDownDateFinal: '',
            locationType: [
                { _id: '1', name: 'In-Person' },
                { _id: '2', name: 'Online' },
            ],
            Hours: { value: '7', label: '7' },
            Mins: { value: '30', label: '30' },
            Stamps: { value: 'AM', label: 'AM' },
            createpopup: false,
            privatepoup: false,
            screeningDate: '',
            screeningendDate:'',
            screeningLimit: 0,
            // shift72Id: '',
            eventiveId:'',
            // waitingRoomEventiveId:'',
            searchWord: '',
            films: [],
            selectedFilm: '',
            screenId: '',
            warningpopUp: false,
            isEdit: false,
            updatedAt: '',
            title: '',
            tempDate: '',

            userMail: '',
            userFname: '',
            userLname: '',
            userList: '',
            filmId: '',

            offset: 0,
            perPage: 50,
            currentPage: 0,
            pageCount: 0,
            invitedUser: 0,

            userEditId: '',
            deleteUser: false,
            searchWordUser: '',
            fileUploading: false,
            fileUploadingWO: false,
            errorMsg: '',

            loaderFlag: false,
            locations: [],
            emptyLocationError: '',
            qaReplayLink: "",
            uploadCSVModal:false

        }
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.userValidator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();

    }

    componentDidMount() {
        if (this.props.match && this.props.match.params.id) {
            this.setState({ screenId: this.props.match.params.id, isEdit: true, loaderFlag: true })
            this.apiserve.sendevent("privateScreeningPartner|screen|getById", { id: this.props.match.params.id });
            var data = {
                page: this.state.offset,
                limit: this.state.perPage,
                screenId: this.props.match.params.id
            }
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|getList", data);
        }
        if (this.props.allInitial && this.props.allInitial.location && this.props.allInitial.location.locations) {
            this.setState({ locations: this.props.allInitial.location.locations })
        }
        this.getList();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true,
                userList: []
            },
            () => {
                var data = {
                    page: offset,
                    limit: this.state.perPage,
                    screenId: this.state.screenId
                }
                this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|getList", data);
            }
        );
    };

    getData = () => {
        var self = this
        const selectedPage = this.state.currentPage;
        const offset = this.state.currentPage + 1;
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case "privateScreeningPartner|screen|searchFilm":
                    if (!response.error) {
                        this.setState({
                            films: response.data.docs || [],
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|screen|create":
                    if (!response.error) {
                        this.apiserve.success("Screening Added Sucessfully")
                        this.setState({
                            screenId: response.data
                        })
                        this.apiserve.sendevent("privateScreeningPartner|screen|getById", { id: response.data });

                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|screen|edit":
                    if (!response.error) {
                        this.apiserve.sendevent("privateScreeningPartner|screen|getById", { id: this.state.screenId });
                        this.apiserve.success("Screening Updated Sucessfully")
                        this.setState({
                            screenId: response.data._id
                        })
                    } else {
                        this.apiserve.error(response.data.error)

                    }
                    break;
                case "privateScreeningPartner|screen|getById":
                    if (!response.error) {
                        var item = response.data
                        let hoursStart = moment(item.screeningDate).tz("US/Mountain").format('h');
                        let minutesStart = moment(item.screeningDate).tz("US/Mountain").format('mm')
                        let stateStart = moment(item.screeningDate).tz("US/Mountain").format('A')
                        let yearstart = moment(item.screeningDate).tz("US/Mountain").format('YYYY')
                        let monthstart = moment(item.screeningDate).tz("US/Mountain").format('MM') - 1
                        let datestart = moment(item.screeningDate).tz("US/Mountain").format('DD')
                        let tempDate = moment(item.screeningendDate).tz("US/Mountain").format('MMM DD, YYYY - hh:mm A');
                        let hoursEnd = moment(item.screeningendDate).tz("US/Mountain").format('h');
                        let minutesEnd = moment(item.screeningendDate).tz("US/Mountain").format('mm')
                        let stateEnd = moment(item.screeningendDate).tz("US/Mountain").format('A')
                        let yearEnd = moment(item.screeningendDate).tz("US/Mountain").format('YYYY')
                        let monthEnd = moment(item.screeningendDate).tz("US/Mountain").format('MM') - 1
                        let dateEnd = moment(item.screeningendDate).tz("US/Mountain").format('DD')
                        this.setState({
                            displayDate: tempDate,
                            screeningDate: new Date(yearstart, monthstart, datestart),
                            screeningendDate:new Date(yearEnd, monthEnd, dateEnd),
                            Hours: { value: hoursStart, label: hoursStart },
                            Mins: { value: minutesStart, label: minutesStart },
                            Stamps: { value: stateStart, label: stateStart },
                            EndHours: { value: hoursEnd, label: hoursEnd },
                            EndMins: { value: minutesEnd, label: minutesEnd },
                            EndStamps: { value: stateEnd, label: stateEnd },
                            // shift72Id: item.shift72Id,
                            eventiveId: item.eventiveId,
                            // waitingRoomEventiveId: item.waitingRoomEventiveId,
                            screeningLimit: item.screeningLimit,
                            updatedAt: item.updatedAt ? moment(item.updatedAt).tz('US/Mountain').format('hh:mm A - MM/DD/YYYY') : '',
                            isEdit: true,
                            title: item.filmId && item.filmId.title ? item.filmId.title : '',
                            filmId: item.filmId && item.filmId._id,
                            locationTypeText: item ?.locationType ? item ?.locationType : '1',
                            screenLocation: item.locations.length > 0 ? this.getLocations(item.locations) : item.locations,
                            qaReplayLink: response.data.qaReplayLink,
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|create":
                    if (!response.error) {
                        this.setState({
                            createOpen: false,
                            userList: [],
                            currentPage: selectedPage,
                            offset: offset,
                            searchWordUser: '',
                            isEditAddDisable:false
                        }, () => {
                            this.getList();
                        })
                        this.apiserve.success("User Created Sucessfully");
                    } else {
                        if (response.code === '412') {
                            this.setState({ privatepoup: true, createOpen: false })
                        } else {
                            this.setState({ createOpen: false })
                            this.apiserve.error(response.data.error)
                        }
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|edit":
                    if (!response.error) {
                        this.setState({
                            createOpen: false, userList: [], currentPage: selectedPage,
                            offset: offset, userEditId: '', userEditItem: '',
                            searchWordUser: '',
                            isEditAddDisable:false

                        }, () => {
                            this.getList();
                        })
                        this.apiserve.success("User Updated Sucessfully")
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|getList":
                    if (!response.error) {
                        this.setState({ userList: [], invitedUser: response.data.docs && response.data.docs.length, pageCount: Math.ceil(response.data.totalDocs / self.state.perPage) }, () => { this.setState({ userList: response.data.docs || [] }) });
                        this.NoPrivatePoup()
                    } else {
                        this.NoPrivatePoup()
                        this.apiserve.error(response.data.error)
                    }
                    this.setState({ loaderFlag: false })
                    break;
                case "privateScreeningPartner|privateScreeningUser|remove":
                    if (!response.error) {
                        this.setState({
                            createOpen: false, userList: [], currentPage: selectedPage, userEditId: '', userEditItem: '',
                            offset: offset,
                            deleteUser: false,
                            searchWordUser: '',
                            isRemoveDisable:false
                        }, () => {
                            this.getList();
                        })
                        this.apiserve.success("User Deleted Sucessfully");
                    } else {
                        this.setState({ userEditId: '', userEditItem: '' })
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|searchUser":
                    if (!response.error) {
                        this.setState({ userList: [], pageCount: Math.ceil(response.data.totalDocs / self.state.perPage) }, () => { this.setState({ userList: response.data.docs || [] }) });
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|importCsv":
                    if (!response.error) {
                        this.setState({ fileUploading: false, fileUploadingWO:false })
                        this.apiserve.success("File upload Sucessfully");
                        this.getList();
                    } else {
                        this.setState({ fileUploading: false, fileUploadingWO:false,warningpopUp: true, errorMsg:response.data.error })
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|blockedPrivateScreeningUser":
                    if (!response.error) {
                        var msg = false;
                        if (response.data._id) {
                            var isyes = this.state.userList.find(_ => _._id === response.data._id)
                            if (isyes) {
                                msg = isyes.isBlocked
                            }
                        }
                        this.setState({ userList: [], searchWordUser: '' })
                        if (msg) this.apiserve.success("User is unblocked Sucessfully")
                        else this.apiserve.success("User is blocked Sucessfully")
                        this.setState({ userList: [], searchWordUser: '' })
                        this.getList();
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|invitationLink":
                    if (!response.error) {
                        CopyToClipboard((response.data && response.data.link) || '');
                        this.apiserve.success('Link Copied!')
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;

                case "privateScreeningPartner|privateScreeningUser|sendMail":
                    if (!response.error) {
                        var data = {
                            page: this.state.offset,
                            limit: this.state.perPage,
                            screenId: this.props.match.params.id
                        }
                        this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|getList", data);
                        this.apiserve.success('Email sent sucessfully')
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;

                case "privateScreeningPartner|privateScreeningUser|saveGeneraluser":
                    if (!response.error) {
                        this.setState({ privatepoup: false })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "privateScreeningPartner|front|gostLogin":
                    if (!response.error) {
                        document.cookie = process.env.REACT_APP_ENVIRONMENT +"privateScreeningUser" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                        cookies.remove(process.env.REACT_APP_ENVIRONMENT +"privateScreeningUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });

                        cookies.set(process.env.REACT_APP_ENVIRONMENT +'privateScreeningUser', response.data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: '/', secure: true });

                        window.open(process.env.REACT_APP_FRONTEND_PRIVATE_SCREENING + 'sign-in?screenId=' + self.state.screenId)
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "privateScreeningPartner|privateScreeningUser|getUserCsv":
                    if (!response.error) {
                       window.open(response.data.location, '_blank')
                    }else{
                        this.apiserve.error('CSV Download Failed')
                    }
                    break;
                default:
                    break;
            }
        });
        this.forceUpdate();
    }



    componentDidUpdate(prevProps) {
        if (prevProps.allInitial !== this.props.allInitial) {
            if (this.props.allInitial && this.props.allInitial.location && this.props.allInitial.location.locations) {
                this.setState({ locations: this.props.allInitial.location.locations })
            }
        }
    }

    getList = () => {
        this.setState({ loaderFlag: true })
        var data = {
            page: 0,
            limit: this.state.perPage,
            screenId: this.state.screenId
        }
        setTimeout(() => {
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|getList", data);
        }, 200);
    }
    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    submitScreen = () => {
     
        if (this.state.isEdit) {
            this.validator.errorMessages.Film = null;
            this.validator.fields.Film = true
        }
        var locationError = false;
        if (this.state.locationTypeText === '1') {
            if (this.state.screenLocation && this.state.screenLocation.length !== 0) {
                locationError = false
                this.setState({ emptyLocationError: '' })
            } else {
                locationError = true
                this.setState({ emptyLocationError: 'Location is required.' })
            }
        }
        if (this.validator.allValid() && locationError === false) {
            var screeningDate = new Date(this.state.screeningDate);
            var screeningendDate = new Date(this.state.screeningendDate);

            screeningDate.setHours(this.state.Stamps.value === 'PM' || this.state.Stamps.value === 'pm' ?
                parseInt(this.state.Hours.value) === 12 ?
                    parseInt(this.state.Hours.value) : parseInt(this.state.Hours.value) + 12 : parseInt(this.state.Hours.value) === 12 ? parseInt(this.state.Hours.value) - 12 : parseInt(this.state.Hours.value), this.state.Mins.value);
                    
            screeningendDate.setHours(this.state.EndStamps.value === 'PM' || this.state.EndStamps.value === 'pm' ?
                    parseInt(this.state.EndHours.value) === 12 ?
                        parseInt(this.state.EndHours.value) : parseInt(this.state.EndHours.value) + 12 : parseInt(this.state.EndHours.value) === 12 ? parseInt(this.state.EndHours.value) - 12 : parseInt(this.state.EndHours.value), this.state.EndMins.value);

            var data = {
                screeningendDate : this.getMtTime(screeningendDate),
                screeningDate: this.getMtTime(screeningDate),
                screeningLimit: this.state.screeningLimit,
                eventiveId: this.state.eventiveId,
                locationType: this.state.locationTypeText,
                locations: this.state ?.screenLocation.length > 0 ? this.state ?.screenLocation[0] ?.value ? [this.state.screenLocation[0] ?.value] : [] :[this.state.screenLocation ?.value],
                qaReplayLink: this.state.qaReplayLink,
                locationEventiveId:this.state.screenLocation.locationEventiveId 
            }
            if (this.state.selectedFilm && this.state.selectedFilm._id) data.filmId = this.state.selectedFilm._id;
            if (this.state.screenId) {
                data.screenId = this.state.screenId;
                if(this.state.locationTypeText === "2"){
                    delete data['locations']
                    delete data['locationEventiveId']
                }
                this.apiserve.sendevent("privateScreeningPartner|screen|edit", data);
            } else {
                if(this.state.locationTypeText === "2"){
                    delete data['locations']
                    delete data['locationEventiveId']
                }
                delete data['eventiveId']
                this.apiserve.sendevent("privateScreeningPartner|screen|create", data);
            }
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    sendMail = (item) => {
        var self = this;
        if (item) {
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|sendMail", { email: item ?.userId ?.email ? item ?.userId ?.email : item.email , screenId: self.state.screenId, userId: item ?.userId ? item.userId._id : item._id});
        }
    }

    createUser = (e, isAddUser) => {
        e.preventDefault();
        if (this.userValidator.allValid()) {
            var data = {
                email: this.state.userMail,
                fname: this.state.userFname,
                lname: this.state.userLname,
                isAddUser:isAddUser
            }
            if (this.state.userEditId) {
                data.id = this.state.userEditId;
                this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|edit", data);
            } else {
                data.filmId = this.state.filmId;
                data.screenId = this.state.screenId;
                this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|create", data);
            }
        }
        else {
            this.userValidator.showMessages();
            this.forceUpdate();
        }
    }
    clearUser = () => {
        this.userValidator.hideMessages();
        if (this.state.userEditId) {
            this.setState({
                userFname: '',
                userLname: '',
                userEditItem: ''
            })
        } else {
            this.setState({
                userMail: '',
                userFname: '',
                userLname: '',
                userEditItem: ''
            })
        }

    }

    CreatePartner = () => {
        if (this.state.screenId) {
            this.clearUser();
            this.setState({
                createOpen: true,
                warningpopUp: false
            })
        } else {
            this.setState({
                errorMsg: 'Please save screening before create user',
                warningpopUp: true
            })
        }
        this.forceUpdate();
    }

    closePartnerUser = () => {
        this.setState({
            createOpen: false
        })
    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.name === 'userMail' ? e.target.value.trim() : e.target.value
        });
    }

    handleChangeDate = (date, id) => {
        this.setState({
            screeningDate: date
        })
    }
    handleChangeEndDate = (date, id) => {
        this.setState({
            screeningendDate: date
        })
    }
    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    dropChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: { value: value, label: name }
        })
    }

    handleTimeHours = (e) => {
        this.setState({
            Hours: e
        })
    }
    handleTimeEndHours = (e) => {
        this.setState({
            EndHours: e
        })
    }


    handleTimeMin = (e) => {
        this.setState({
            Mins: e
        })
    }
    handleEndTimeMin = (e) => {
        this.setState({
            EndMins: e
        })
    }

    handleTimeStamps = (e) => {
        this.setState({
            Stamps: e
        })
    }
    handleEndTimeStamps = (e) => {
        this.setState({
            EndStamps: e
        })
    }
    getLocations = (locations) => {
        return locations && locations.length > 0 && locations.map(item => {
            var location = {
                value: item._id, label: item.name, isSet: item.isSet, city: item.city, state: item.state,locationEventiveId: item.eventiveId 
            }
            return location
        })
    }
    handleEvent = (e) => {
        let { value, id } = e.target
        this.setState({ locationTypeText: `${value}` });
    }

    //Location Master Call
    locationOption = () => {
        var options = []
        this.state.locations && this.state.locations.forEach(item => {
            if (item._id !== '934e67c906e26dd0737c')
                options.push({ value: item._id, label: item.name, isSet: item.isSet, city: item.city, state: item.state,locationEventiveId: item.eventiveId })
        });
        return options
    }

    handleChangeLocation = (value) => {
        if (value !== null || value && value.length !== 0) this.setState({ emptyLocationError: '' })
        else this.setState({ emptyLocationError: 'Location is required.' })
        this.setState({ screenLocation: value })
    }

    searchFilm = (e) => {
        if (e.target.value) {
            this.setState({ searchWord: e.target.value });
            this.apiserve.sendevent("privateScreeningPartner|screen|searchFilm", { filter: e.target.value });
        } else {
            this.setState({ films: [] })
            this.setState({ searchWord: e.target.value });
        }
    }
    searchUser = (e) => {
        if (e.target.value) {
            this.setState({ searchWordUser: e.target.value });
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|searchUser", { limit: this.state.perPage, page: 0, filter: e.target.value, screenId: this.state.screenId });
        } else {
            this.setState({ userList: [] })
            this.setState({ searchWordUser: e.target.value, loaderFlag: true });
            var data = {
                page: 0,
                limit: this.state.perPage,
                screenId: this.state.screenId
            }
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|getList", data);
        }
    }

    handleSelectFilm = (e, item) => {
        this.setState({
            searchWord: item.title,
            selectedFilm: item,
            films: []
        });
    }

    closePrivatePoup = () => {
        this.setState({ privatepoup: false, createOpen: false, userList: [] });
        this.getList();
        this.clearUser();
    }

    NoPrivatePoup = () => {
        this.setState({ privatepoup: false, createOpen: false,});
        this.clearUser();
    }

    userEdit = (item) => {
        if (item) {
            this.setState({
                userEditId: item._id,
                userMail: item.email,
                userFname: item.fname,
                userLname: item.lname,
                createOpen: true
            })
        }
    }

    deleteUser = (item) => {
        if (item) {
            this.setState({ deleteUser: true, userEditItem: item, userEditId: item._id })
        }
    }

    deleteFilmPopupYes = () => {

        var data = {
            id: this.state.userEditId,
            screenId: this.state.screenId
        }
        if (this.state.userEditItem && !this.state.userEditItem.userId) {
            data.screenId = this.state.screenId;
        }
        this.setState({
            isRemoveDisable:true
        })

        this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|remove", data);

    }
    closeAdminUser = () => {
        this.setState({
            deleteUser: false,
            userEditId: '',
            userEditItem: ''
        })
    }

    uploadCSV = (e, TYPE) => {
        if (e.target.files[0]) {
            this.setState({
                fileUploading:  TYPE ==='WITH' ? true : false,
                fileUploadingWO : TYPE ==='WITHOUT' ? true : false
            })
            let file = e.target.files[0];
            if ((file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') || file.name.includes('.csv')) {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = (event) => {
                    setTimeout(() => {
                        this.imageUploadScreen(file, TYPE,event.target.result);
                    }, 0);
                };
            } else {
                this.setState({ errorMsg: 'please upload .csv file only', warningpopUp: true, fileUploading: false, fileUploadingWO: false })
            }
            
        }
    }
    imageUploadScreen = (file, TYPE, img) => {
        var self = this;
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
            var data1 = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value),
                filmId: self.state.filmId,
                screenId: self.state.screenId,
                skipEmailSend: TYPE === 'WITHOUT' ? true : false
            }
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|importCsv", data1);
        });
    };
    blockUser = (item) => {
        var self = this
        if (item) {
            var data = {
                userId: item._id,
                isBlocked: !item.isBlocked,
            }
            if (item.isBlocked) {
                var datas = {
                    uid: item._id,
                    screenId: self.state.screenId
                }
            }
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|blockedPrivateScreeningUser", data);
        }
    }

    getInvitationLink = () => {
        if (this.state.screenId) {
            this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|invitationLink", { screenId: this.state.screenId });
        }
    }
    clearFilm = () => {
        this.setState({ films: [] })
    }
    loginUser = (item) => {
        var self = this
        if (item) {
            let data = {
                userId: item ?.userId ?._id ? item ?.userId ?._id : item._id,
                screenId: self.state.screenId
            }
            this.apiserve.sendevent("privateScreeningPartner|front|gostLogin", data);
        }
        
    }
    
    downloadUserCsv = ()=>{
        let data = {
            screenId:this.state.screenId
        }
        this.apiserve.sendevent("privateScreeningPartner|privateScreeningUser|getUserCsv", data);
        
    }

    CloseModal = () => {
        this.setState({
            uploadCSVModal:false
        })
    }

    render() {
        const Hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]

        const Mins = [
            { value: '00', label: '00' },
            { value: '05', label: '05' },
            { value: '10', label: '10' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

        const Stamps = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
        let profileName = '';
        let data = JSON.parse(localStorage.getItem('persist:root'));
        if (data && data.profileName) {
            profileName = JSON.parse(data.profileName);
        }
        return (
            <>
            <div className="right_side_wrapper adminDashboard_wrapper">
                <div className="dashboard_header with_btn profile_header">
                    <div className="searchBlock p_0 mx_100">
                        <span className="d_flex d_flex_align_center"> <Link to='/partners-profile' ><span>
                            {profileName && profileName.fname ? profileName.fname + ' ' + profileName.lname : ''}</span> </Link>&nbsp;&nbsp;
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.75 1.75C2.75 1.94778 2.69135 2.14112 2.58147 2.30557C2.47159 2.47002 2.31541 2.59819 2.13268 2.67388C1.94996 2.74957 1.74889 2.76937 1.55491 2.73079C1.36093 2.6922 1.18275 2.59696 1.04289 2.45711C0.903041 2.31725 0.8078 2.13907 0.769215 1.94509C0.73063 1.75111 0.750433 1.55004 0.826121 1.36732C0.901809 1.18459 1.02998 1.02841 1.19443 0.918531C1.35888 0.80865 1.55222 0.750001 1.75 0.750001C2.01522 0.750001 2.26957 0.855357 2.45711 1.04289C2.64464 1.23043 2.75 1.48478 2.75 1.75ZM6 0.750001C5.80222 0.750001 5.60888 0.80865 5.44443 0.918531C5.27998 1.02841 5.15181 1.18459 5.07612 1.36732C5.00043 1.55004 4.98063 1.75111 5.01922 1.94509C5.0578 2.13907 5.15304 2.31725 5.29289 2.45711C5.43275 2.59696 5.61093 2.6922 5.80491 2.73079C5.99889 2.76937 6.19996 2.74957 6.38268 2.67388C6.56541 2.59819 6.72159 2.47002 6.83147 2.30557C6.94135 2.14112 7 1.94778 7 1.75C7 1.48478 6.89464 1.23043 6.70711 1.04289C6.51957 0.855357 6.26522 0.750001 6 0.750001ZM10.25 2.75C10.4478 2.75 10.6411 2.69135 10.8056 2.58147C10.97 2.47159 11.0982 2.31541 11.1739 2.13268C11.2496 1.94996 11.2694 1.74889 11.2308 1.55491C11.1922 1.36093 11.097 1.18275 10.9571 1.04289C10.8173 0.903041 10.6391 0.8078 10.4451 0.769215C10.2511 0.73063 10.05 0.750433 9.86732 0.826121C9.68459 0.901809 9.52841 1.02998 9.41853 1.19443C9.30865 1.35888 9.25 1.55222 9.25 1.75C9.25 2.01522 9.35536 2.26957 9.54289 2.45711C9.73043 2.64464 9.98478 2.75 10.25 2.75ZM1.75 5C1.55222 5 1.35888 5.05865 1.19443 5.16853C1.02998 5.27841 0.901809 5.43459 0.826121 5.61732C0.750433 5.80004 0.73063 6.00111 0.769215 6.19509C0.8078 6.38907 0.903041 6.56725 1.04289 6.70711C1.18275 6.84696 1.36093 6.9422 1.55491 6.98079C1.74889 7.01937 1.94996 6.99957 2.13268 6.92388C2.31541 6.84819 2.47159 6.72002 2.58147 6.55557C2.69135 6.39112 2.75 6.19778 2.75 6C2.75 5.73478 2.64464 5.48043 2.45711 5.29289C2.26957 5.10536 2.01522 5 1.75 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01922 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM10.25 5C10.0522 5 9.85888 5.05865 9.69443 5.16853C9.52998 5.27841 9.40181 5.43459 9.32612 5.61732C9.25043 5.80004 9.23063 6.00111 9.26922 6.19509C9.3078 6.38907 9.40304 6.56725 9.54289 6.70711C9.68275 6.84696 9.86093 6.9422 10.0549 6.98079C10.2489 7.01937 10.45 6.99957 10.6327 6.92388C10.8154 6.84819 10.9716 6.72002 11.0815 6.55557C11.1914 6.39112 11.25 6.19778 11.25 6C11.25 5.73478 11.1446 5.48043 10.9571 5.29289C10.7696 5.10536 10.5152 5 10.25 5ZM1.75 9.25C1.55222 9.25 1.35888 9.30865 1.19443 9.41853C1.02998 9.52841 0.901809 9.68459 0.826121 9.86732C0.750433 10.05 0.73063 10.2511 0.769215 10.4451C0.8078 10.6391 0.903041 10.8173 1.04289 10.9571C1.18275 11.097 1.36093 11.1922 1.55491 11.2308C1.74889 11.2694 1.94996 11.2496 2.13268 11.1739C2.31541 11.0982 2.47159 10.97 2.58147 10.8056C2.69135 10.6411 2.75 10.4478 2.75 10.25C2.75 9.98478 2.64464 9.73043 2.45711 9.54289C2.26957 9.35536 2.01522 9.25 1.75 9.25ZM6 9.25C5.80222 9.25 5.60888 9.30865 5.44443 9.41853C5.27998 9.52841 5.15181 9.68459 5.07612 9.86732C5.00043 10.05 4.98063 10.2511 5.01922 10.4451C5.0578 10.6391 5.15304 10.8173 5.29289 10.9571C5.43275 11.097 5.61093 11.1922 5.80491 11.2308C5.99889 11.2694 6.19996 11.2496 6.38268 11.1739C6.56541 11.0982 6.72159 10.97 6.83147 10.8056C6.94135 10.6411 7 10.4478 7 10.25C7 9.98478 6.89464 9.73043 6.70711 9.54289C6.51957 9.35536 6.26522 9.25 6 9.25ZM10.25 9.25C10.0522 9.25 9.85888 9.30865 9.69443 9.41853C9.52998 9.52841 9.40181 9.68459 9.32612 9.86732C9.25043 10.05 9.23063 10.2511 9.26922 10.4451C9.3078 10.6391 9.40304 10.8173 9.54289 10.9571C9.68275 11.097 9.86093 11.1922 10.0549 11.2308C10.2489 11.2694 10.45 11.2496 10.6327 11.1739C10.8154 11.0982 10.9716 10.97 11.0815 10.8056C11.1914 10.6411 11.25 10.4478 11.25 10.25C11.25 9.98478 11.1446 9.73043 10.9571 9.54289C10.7696 9.35536 10.5152 9.25 10.25 9.25Z" fill="white" />
                            </svg> &nbsp;&nbsp;
                        <Link to='/partner-screening-list'><span>  Screenings ({localStorage.getItem('filmListlength') || 0})  &nbsp;&nbsp;</span> </Link> &gt; &nbsp;&nbsp;{this.state.isEdit ? <><label className="color_yellow"> {this.state.title} </label> &nbsp;&nbsp;&nbsp; <label>{this.state.displayDate}</label> </> : 'Add Screening'}
                        </span>
                    </div>
                </div>
                {
                    this.state.isEdit && <div className="back_date d_flex d_flex_justify_end" >
                        <p className="update_date">Last Update: {this.state.updatedAt}</p>
                    </div>
                }
                <div className="theme_light_bg">
                    <div className="partner_edit_header product_coupon_form d_flex d_flex_align_center d_flex_justify_spacebt">
                        <div className="field_row horizontal_field w_100">
                            <div className="field_row_inner scerrning_eventive">
                                <label>Eventive ID:</label>
                                <p>{this.state.eventiveId}</p>
                            </div>
                        </div>
                        <div className="field_row horizontal_field w_100">
                            {
                                !this.state.isEdit ? <div className="field_row_inner">
                                    <label>Search Film</label>
                                    <div className="field_input relative ">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="searchWord"
                                                value={this.state.searchWord}
                                                placeholder="Select Film"
                                                onChange={(e) => this.searchFilm(e)}
                                                autocomplete="off"
                                            />
                                        </div>
                                        <span style={{ color: 'red' }}>{this.validator.message('Film', this.state.selectedFilm, 'required')}</span>
                                        <ul className="suggession_coupon">
                                            {this.state.films &&
                                                this.state.films.map(item => (
                                                    <li onClick={e => this.handleSelectFilm(e, item)}>{item.title}</li>
                                                ))}
                                        </ul>
                                    </div>
                                </div> : ""
                            }


                        </div>
                        <div className="d_flex w_100 d_flex_justify_spacebt">
                            <div className="single_date_time m_0">
                                <div className="field_row">
                                    <div className="form_group form_group_input  d_flex d_flex_align_center">
                                        <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                            <label>Event Date & Time (MT)</label>
                                            <div className="form_group_countdown d_flex d_flex_align_center">
                                                <TextField type="text" name="date"
                                                    value={this.state.screeningDate ? moment(this.state.screeningDate).format(
                                                        "MM/DD/YYYY"
                                                    ) : ''}
                                                    placeholder="mm / dd / yyyy"
                                                    onChange={() => this.setState({})}
                                                />

                                                <span className="calendar_img">
                                                    <DatePicker
                                                        selected={this.state.screeningDate ? this.state.screeningDate : ''}
                                                        onChange={(e) => this.handleChangeDate(e)}
                                                        minDate={moment().toDate()}
                                                        placeholder="mm/dd/yyyy"
                                                        name='screeningDate'
                                                        customInput={
                                                            <span className="calendar">
                                                                <CalendarIcon />
                                                            </span>
                                                        }
                                                    />
                                                </span>

                                                <Select
                                                    options={Hours}
                                                    value={this.state.Hours}
                                                    name='Hours'
                                                    placeholder="7"
                                                    onChange={(e) => this.handleTimeHours(e)}
                                                />
                                                <Select
                                                    options={Mins}
                                                    value={this.state.Mins}
                                                    name='Mins'
                                                    placeholder="30"
                                                    onChange={(e) => this.handleTimeMin(e)}
                                                />

                                                <Select
                                                    options={Stamps}
                                                    value={this.state.Stamps}
                                                    name='Stamps'
                                                    placeholder="AM"
                                                    onChange={(e) => this.handleTimeStamps(e)}
                                                />

                                            </div> <span className='ml_5'>-</span>
                                        </div>
                                    </div>


                                </div>
                                <div className="field_row horizontal_field w_100 d_flex">
                                    <label></label>
                                    <div className="field_input relative">
                                        <span style={{ color: 'red' }}>{this.validator.message('Screening Date', this.state.screeningDate, 'required')}</span>
                                        <span style={{ color: 'red' }}>{this.validator.message('Hours', this.state.Hours, 'required')}</span>
                                        <span style={{ color: 'red' }}>{this.validator.message('Minute', this.state.Mins, 'required')}</span>
                                        <span style={{ color: 'red' }}>{this.validator.message('Stamps', this.state.Stamps, 'required')}</span>
                                    </div>
                                </div>
                                <div className="single_date_time m_0">
                                <div className="field_row">
                                    <div className="form_group form_group_input  d_flex d_flex_align_center">
                                        <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                            <label></label>
                                            <div className="form_group_countdown d_flex d_flex_align_center">
                                                <TextField type="text" name="Enddate"
                                                    value={this.state.screeningendDate ? moment(this.state.screeningendDate).format(
                                                        "MM/DD/YYYY"
                                                    ) : ''}
                                                    placeholder="mm / dd / yyyy"
                                                    onChange={() => this.setState({})}
                                                />

                                                <span className="calendar_img">
                                                    <DatePicker
                                                        selected={this.state.screeningendDate ? this.state.screeningendDate : ''}
                                                        onChange={(e) => this.handleChangeEndDate(e)}
                                                        minDate={moment().toDate()}
                                                        placeholder="mm/dd/yyyy"
                                                        name='screeningendDate'
                                                        customInput={
                                                            <span className="calendar">
                                                                <CalendarIcon />
                                                            </span>
                                                        }
                                                    />
                                                </span>

                                                <Select
                                                    options={Hours}
                                                    value={this.state.EndHours}
                                                    name='Hours'
                                                    placeholder="7"
                                                    onChange={(e) => this.handleTimeEndHours(e)}
                                                />
                                                <Select
                                                    options={Mins}
                                                    value={this.state.EndMins}
                                                    name='Mins'
                                                    placeholder="30"
                                                    onChange={(e) => this.handleEndTimeMin(e)}
                                                />

                                                <Select
                                                    options={Stamps}
                                                    value={this.state.EndStamps}
                                                    name='Stamps'
                                                    placeholder="AM"
                                                    onChange={(e) => this.handleEndTimeStamps(e)}
                                                />

                                            </div> 
                                        </div>
                                    </div>


                                </div>
                                <div className="field_row horizontal_field w_100 d_flex">
                                    <label></label>
                                    <div className="field_input relative">
                                        <span style={{ color: 'red' }}>{this.validator.message('Screening Date', this.state.screeningendDate, 'required')}</span>
                                        <span style={{ color: 'red' }}>{this.validator.message('Hours', this.state.EndHours, 'required')}</span>
                                        <span style={{ color: 'red' }}>{this.validator.message('Minute', this.state.EndMins, 'required')}</span>
                                        <span style={{ color: 'red' }}>{this.validator.message('Stamps', this.state.EndStamps, 'required')}</span>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="screening_limit" style={{maxWidth:'500px',width:'100%'}}>
                                <div className='d_flex '>
                                </div>
                                <div className="field_row horizontal_field form_group_countdown QA_Link">
                                    <TextField
                                        label="QA Link"
                                        placeholder="https://video.com"
                                        name="qaReplayLink" id="qaReplayLink"
                                        value={this.state.qaReplayLink}
                                        onChange={this.onInputChange}
                                    />
                                    <span style={{ color: 'red' }}>{this.validator.message('qa Link', this.state.qaReplayLink, 'urlValidation')}</span>
                                </div>
                            </div>
                            <div className="field_row">
                                <button onClick={() => this.props.history.push('/partner-screening-list')}>CANCEL</button>
                                <button className="active" onClick={() => this.submitScreen()}>SAVE</button>
                            </div>
                        </div>
                        <div className="field_row d_flex mb_0">
                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                <label></label>
                                <DropdownMaster
                                    name="locationType"
                                    onChange={(e) => this.handleEvent(e)}
                                    value={this.state.locationTypeText}
                                    options={this.state.locationType}
                                    selectedDrop={true}
                                />

                            </div>
                            {this.state.locationTypeText === '1' &&
                                <div className="field_row horizontal_field mb_0">
                                    <div className="d_flex mb_0 d_flex_align_center">
                                        <label></label>
                                        <div className="field_row horizontal_field width_265 mb_0 location_col">
                                            <div className="field_row_inner field_row_location">
                                                <label className='locationLabel'>Location</label>
                                                <div className="select_field relative">
                                                    <Select
                                                        // isMulti
                                                        onChange={(e) => this.handleChangeLocation(e)}
                                                        options={this.locationOption()}
                                                        value={this.state.screenLocation}
                                                    />
                                                </div>

                                            </div>
                                            {this.state.emptyLocationError &&
                                                <span className="error srv-validation-message w_100 " style={{ color: 'red', marginLeft: 125 }}>{this.state.emptyLocationError}</span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="dashboard_header with_btn bgpurple">
                    <div className="searchBlock searchBlock_mb_center">
                        <span>Invited Users ({(this.state.invitedUser) || 0})</span>
                        <form onSubmit={(e) => e.preventDefault(e)}>
                            <input type="text" placeholder="Search" onChange={(e) => this.searchUser(e)} />
                        </form>
                    </div>
                    <div className="button_block d_flex admin_user_twoBtn">
                    <div className="icon_block cloude_icon">
                                <Link onClick={() => this.downloadUserCsv()}><img src={cloud} alt=''/></Link>
                            </div>
                        <span className="head_btn icon_block_btn pointer" onClick={this.getInvitationLink}>Invitation Link</span>
                        <span className="head_btn icon_block_btn pointer" onClick={this.CreatePartner}>Create User</span>
                        <span className="head_btn icon_block_btn pointer upload_csv_btn"><input type="file" accept='.csv' onChange={(e) => this.uploadCSV(e, 'WITH')} /><span>Upload CSV</span>{this.state.fileUploading &&
                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }</span>
                        <span className="head_btn icon_block_btn pointer upload_csv_btn"><input type="file" accept='.csv' onChange={(e) => this.uploadCSV(e, 'WITHOUT')} /><span>Upload CSV (Without Email)</span>{this.state.fileUploadingWO &&
                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }</span>
                    </div>
                </div>
                <div className="dashboard_data" style={{ height: "calc(100% - 400px)" }}>
                    <div className="partner_tbl">
                        {
                            this.state.userList && this.state.userList.length > 0 ?
                                <PartnerEditScreeningTable
                                    docs={this.state.userList || []}
                                    userEdit={this.userEdit}
                                    userDelete={this.deleteUser}
                                    blockUser={this.blockUser}
                                    sendMail={this.sendMail}
                                    loginUser={(e) => this.loginUser(e)}
                                /> : ''
                        }
                    </div>

                    {this.state.userList && this.state.pageCount > 0 ? (
                        <div className="custom-pagination pagination_mb">
                            <ReactPaginate
                                previousLabel={""}
                                nextLabel={""}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    ) : (
                            ""
                        )}
                </div>
            </div>
            {
                this.state.createOpen ?
                    <div className="private_screening_popup">
                        <div className="header">
                            <h2 className="text_center"> {this.state.userEditId ? "Edit Private Screening User " : 'Create Private Screening User'}</h2>
                            <span className="close_modal" onClick={() => this.setState({ createOpen: false, userMail: '', userFname: '', userLname: '', userEditId: '', userEditItem: '' })}>
                                <img src="/images/close.svg" alt="close" />
                            </span>
                        </div>
                        <div className="content">
                            <form onSubmit={(e) => this.createUser(e, false)}>
                                <div className="field_row horizontal_field pb_10" tabindex='1'>
                                    <TextField tabindex='1' label="Email" disable={this.state.userEditId ? true : false} name='userMail' value={this.state.userMail} onChange={(e) => this.onInputChange(e)}
                                        fpgerror={this.userValidator.message('Email', this.state.userMail, 'required|email')}
                                    />
                                </div>
                                <div className="field_row horizontal_field pb_10" >
                                    <TextField tabindex='2' label="First Name" name='userFname' value={this.state.userFname} onChange={(e) => this.onInputChange(e)}
                                        fpgerror={this.userValidator.message('First Name', this.state.userFname, 'required')}
                                    />
                                </div>
                                <div className="field_row horizontal_field pb_10">
                                    <TextField tabindex='3' label="Last Name" name='userLname' value={this.state.userLname} onChange={(e) => this.onInputChange(e)}
                                        fpgerror={this.userValidator.message('Last Name', this.state.userLname, 'required')}
                                    />
                                </div>
                                <div className="field_row text_center pt_25 mt_15 ">
                                    <button tabindex='5' className="uppercase" type='button' onClick={() => this.clearUser()}>Clear</button>
                                    <button tabindex='4' className="active uppercase" type='submit' disabled={this.state.isEditAddDisable} onSubmit={(e) => this.createUser(e, false)} >Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    :
                    ""
            }
            {
                this.state.privatepoup ?
                    <div className="private_screening_popup">
                        <div className="header">
                            <h2 className="text_center"> Create Private Screening User </h2>
                            <span className="close_modal" onClick={() => this.setState({ privatepoup: false })}>
                                <img src="/images/close.svg" alt="close" />
                            </span>
                        </div>
                        <div className="content text_center">
                            <p className="pb_15">The following user already exists</p>
                            <div className="pb_25">
                                <p className="pb_25 font_500"><a className="color_blue">{this.state.userMail} </a>   - {this.state.userFname} {this.state.userLname} </p>
                                <p className="font_600">Do you want to select this user?</p>
                            </div>
                            <div className="field_row text_center pt_25 mt_15 ">
                                <button className="uppercase" onClick={() => this.closePrivatePoup()}>NO</button>
                                <button className="active uppercase" disabled={this.state.isEditAddDisable} onClick={(e) => this.createUser(e,true)}>YES</button>
                            </div>
                        </div>
                    </div>
                    :
                    ""
            }
            {this.state.uploadCSVModal ? <CsvUploadModalScreening CloseModal={this.CloseModal} totalSkippedRecord={this.state.totalSkippedRecord} totalAddedRecord={this.state.totalAddedRecord} skippedUser={this.state.skippedUser} /> : ''}
            {this.state.warningpopUp ? (
                <ErrorPopUp
                    errorMsg={this.state.errorMsg}
                    errorMsgPopup={() => this.setState({ warningpopUp: false, errorMsg: '' }, () => {
                        this.getList()
                    })}
                />
            ) : (
                    ""
                )}

            {this.state.deleteUser ?
                <PopUpCustomAll
                    HeaderName='Delete?'
                    insideDetails='You are about to delete an item and this action is permanent'
                    insideData='Do you want to proceed?'
                    popupState={this.closeAdminUser}
                    isDisable={this.state.isRemoveDisable}
                    yesPopUp={() => this.deleteFilmPopupYes()}
                />
                : ''}

            {this.state.loaderFlag ? (
                <Loader />
            ) : (
                    ""
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    allInitial: state.allInitial,
});

export default connect(mapStateToProps)(PartnersEditScreenings);
